import { render, staticRenderFns } from "./TotalGain.vue?vue&type=template&id=61076ef8"
import script from "./TotalGain.vue?vue&type=script&lang=js"
export * from "./TotalGain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports